<template>
    <b-sidebar
        id="contract-sidebar"
        :visible="isSidebarActive"
        width="40%"
        bg-variant="white"
        sidebar-class="sidebar-lg"
        shadow
        backdrop
        no-header
        right
        @change="(val) => $emit('update:is-sidebar-active', val)"
    >
        <template #default="{ hide }">
            <!-- Header -->
            <div
                class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
            >
                <h5 class="mb-0 text-primary">
                    Editar Contrato {{ contract.codigo }}
                </h5>

                <feather-icon
                    class="ml-1 cursor-pointer"
                    icon="XIcon"
                    size="16"
                    @click="hide"
                />
            </div>

            <!-- BODY -->

            <b-overlay :show="show" rounded="sm">
                <!-- Form -->
                <b-tabs align="left">
                    <b-tab active>
                        <template #title>
                            <feather-icon icon="FileTextIcon" />
                            <span class="font-weight-bolder">
                                Información
                            </span>
                        </template>
                        <validation-observer
                            ref="ttForm"
                            #default="{ invalid }"
                        >
                            <b-form class="p-2" @submit.prevent="save">
                                <!-- Identificacion -->
                                <validation-provider
                                    #default="validationContext"
                                    name="Identificacion"
                                    rules="required"
                                >
                                    <b-form-group
                                        label="* Identificacion"
                                        label-for="c-identificacion"
                                    >
                                        <b-form-input
                                            id="c-identificacion"
                                            v-model="contract.ruc"
                                            autofocus
                                            :state="
                                                getValidationState(
                                                    validationContext
                                                )
                                            "
                                            trim
                                            placeholder="Identificacion"
                                        />

                                        <b-form-invalid-feedback>
                                            {{ validationContext.errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </validation-provider>

                                <!-- Apellidos -->
                                <validation-provider
                                    #default="validationContext"
                                    name="Apellidos"
                                    rules="required"
                                >
                                    <b-form-group
                                        label="* Apellidos"
                                        label-for="c-apellidos"
                                    >
                                        <b-form-input
                                            id="c-apellidos"
                                            v-model="contract.apellidos"
                                            :state="
                                                getValidationState(
                                                    validationContext
                                                )
                                            "
                                            trim
                                            placeholder="Apellidos"
                                        />

                                        <b-form-invalid-feedback>
                                            {{ validationContext.errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </validation-provider>

                                <!-- Nombres -->
                                <validation-provider
                                    #default="validationContext"
                                    name="Nombres"
                                    rules="required"
                                >
                                    <b-form-group
                                        label="* Nombres"
                                        label-for="c-nombres"
                                    >
                                        <b-form-input
                                            id="c-nombres"
                                            v-model="contract.nombres"
                                            :state="
                                                getValidationState(
                                                    validationContext
                                                )
                                            "
                                            trim
                                            placeholder="Nombres"
                                        />

                                        <b-form-invalid-feedback>
                                            {{ validationContext.errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </validation-provider>

                                <!-- Sobrenombre -->

                                <b-form-group
                                    label="Sobrenombre"
                                    label-for="c-sobrenombre"
                                >
                                    <b-form-input
                                        id="c-sobrenombre"
                                        v-model="contract.sobrenombre"
                                        trim
                                        placeholder="Sobrenombre"
                                    />
                                </b-form-group>

                                <!-- Email -->
                                <b-form-group label="Email" label-for="c-email">
                                    <b-form-input
                                        id="c-email"
                                        v-model="contract.email"
                                        trim
                                        placeholder="Email"
                                    />
                                </b-form-group>

                                <!-- Telefono -->
                                <validation-provider
                                    #default="validationContext"
                                    name="Telefono"
                                    rules="required"
                                >
                                    <b-form-group
                                        label="* Telefono"
                                        label-for="c-telefono"
                                    >
                                        <b-form-input
                                            id="c-telefono"
                                            v-model="contract.telefono"
                                            :state="
                                                getValidationState(
                                                    validationContext
                                                )
                                            "
                                            trim
                                            placeholder="Telefono"
                                        />

                                        <b-form-invalid-feedback>
                                            {{ validationContext.errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </validation-provider>

                                <!-- Direccion -->
                                <validation-provider
                                    #default="validationContext"
                                    name="Direccion"
                                    rules="required"
                                >
                                    <b-form-group
                                        label="* Direccion"
                                        label-for="c-direccion"
                                    >
                                        <b-form-input
                                            id="c-direccion"
                                            v-model="contract.direccion"
                                            :state="
                                                getValidationState(
                                                    validationContext
                                                )
                                            "
                                            trim
                                            placeholder="Direccion"
                                        />

                                        <b-form-invalid-feedback>
                                            {{ validationContext.errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </validation-provider>

                                <!-- Referencia -->

                                <b-form-group
                                    label="Referencia"
                                    label-for="c-referencia"
                                >
                                    <b-form-input
                                        id="c-referencia"
                                        v-model="contract.referencia"
                                        trim
                                        placeholder="Referencia"
                                    />
                                </b-form-group>

                                <!-- Form Actions -->
                                <div class="d-flex mt-2">
                                    <b-button
                                        ref="button"
                                        v-ripple.400="
                                            'rgba(255, 255, 255, 0.15)'
                                        "
                                        variant="primary"
                                        block
                                        class="mr-2"
                                        type="submit"
                                        :disabled="invalid"
                                        hidden
                                    >
                                        Editar
                                    </b-button>
                                    <b-button
                                        v-ripple.400="
                                            'rgba(186, 191, 199, 0.15)'
                                        "
                                        type="button"
                                        variant="outline-secondary"
                                        @click="hide"
                                    >
                                        Cancelar
                                    </b-button>
                                </div>
                            </b-form>
                        </validation-observer>
                    </b-tab>
                </b-tabs>

                <template #overlay>
                    <div class="text-center">
                        <div class="h2 mb-0">
                            <b-icon-watch
                                font-scale="3"
                                animation="cylon"
                            ></b-icon-watch>
                        </div>
                        <h2 class="text-dark">Procesando ....</h2>
                    </div>
                </template>
            </b-overlay>
        </template>
    </b-sidebar>
</template>

<script>
import formValidation from "@core/comp-functions/forms/form-validation";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { email, required } from "@validations";
import {
    BButton,
    BForm,
    BFormFile,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BIcon,
    BIconWatch,
    BInputGroup,
    BInputGroupAppend,
    BOverlay,
    BProgress,
    BSidebar,
    BSpinner,
    BTab,
    BTabs,
} from "bootstrap-vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";

export default {
    components: {
        BProgress,
        BFormFile,
        BOverlay,
        BIcon,
        BIconWatch,
        BSidebar,
        BForm,
        BFormGroup,
        BFormInput,
        BFormInvalidFeedback,
        BButton,
        vSelect,
        ValidationProvider,
        ValidationObserver,
        ToastificationContent,
        BInputGroup,
        BInputGroupAppend,
        BTab,
        BTabs,
        BSpinner,
    },
    directives: {
        Ripple,
    },
    model: {
        prop: "isSidebarActive",
        event: "update:is-add-new-user-sidebar-active",
    },
    props: {
        isSidebarActive: {
            type: Boolean,
            required: true,
        },
        data: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            userData: JSON.parse(localStorage.getItem("userData")),
            timeout: null,
            show: false,
            required,
            email,
            contract: {},
        };
    },
    created() {

    },
    setup() {
        const { refFormObserver, getValidationState, resetForm } =
            formValidation(() => {});

        return {
            refFormObserver,
            getValidationState,
            resetForm,
            required,
            email,
        };
    },
    beforeDestroy() {
        this.clearTimeout();
    },
    methods: {
        save() {
            this.show = true;
            this.$http
                .post("/contrato-editar-callcenter/", {
                    idcontrato: this.contract.idcontrato,
                    ruc: this.contract.ruc,
                    apellidos: this.contract.apellidos,
                    nombres: this.contract.nombres,
                    sobrenombre: this.contract.sobrenombre,
                    email: this.contract.email,
                    telefono: this.contract.telefono,
                    direccion: this.contract.direccion,
                    referencia: this.contract.referencia,
                    idusuario: this.userData.id,
                })
                .then((response) => {
                    this.show = false;

                    let msn = response.data.msn;
                    if (msn == "SI") {
                        this.showToast(
                            "Procesado Correctamente",
                            "success",
                            "CheckCircleIcon"
                        );
                    } else {
                        this.showToast(
                            "Error al Procesar",
                            "danger",
                            "XCircleIcon"
                        );
                    }
                })
                .catch(function (error) {
                    this.show = false;
                    this.showToast(error, "danger", "XCircleIcon");
                });
        },
        clearTimeout() {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
        },
        setTimeout(callback) {
            this.clearTimeout();
            this.timeout = setTimeout(() => {
                this.clearTimeout();
                callback();
            }, 1.0 * 5000);
        },
        //Tomar el objeto de otro componente
        parametros(objeto, id) {
            this.contract = objeto;
            this.contract.idcontrato = id;
        },
        showToast(message, variant, icon) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: message,
                    variant: variant,
                    icon: icon,
                },
            });
        },
    }, //fin methods
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

#event-sidebar {
    .vs__dropdown-menu {
        max-height: 200px !important;
    }
}
</style>
